import React,{Component} from "react";
import {Modal,Button} from 'react-bootstrap';
import errorlogo from "./images/error.png";
import qrlogo from "./images/QR.png";
//import successlogo from "./images/success.png";

import "./header/Header.css";

//const axios = require("axios");
export default class Modalmobileapp extends Component {
    constructor(props) { 
        super(props);
        this.state = {heading:props.heading,
            isLoaded: false,
            modallogo:errorlogo,
            isOpen:true,
            bodytext:"To download and install the app on your device, simply open your device's camera app or a QR code scanner application.and Scan the QR Code. Your device's browser will start downloading the file. After successful downloading, browse the 'Download' folder of your device and install the app."
        }
        this.closeModal = this.closeModal.bind(this);
        this.openModal = this.openModal.bind(this);

      }
    openModal(e){
      this.setState({ isOpen: true })
    }
    closeModal(e){
      this.props.ErrHandler;
      this.setState({ isOpen: false });
    }
    componentDidMount()
    {

      console.log("kaleem");
    }    
  render()
  {
      return(
        <React.Fragment>
        <Modal show={this.state.isOpen} onHide={this.closeModal}  backdrop="static" aria-labelledby="contained-modal-title-vcenter" animation={false} centered  >
          <Modal.Header style={{backgroundColor:"black", color:"white", height:"40px", paddingTop:5}}>
            <Modal.Title style={{ paddingTop:7,fontSize:12}}> Downloading mobile application</Modal.Title>
          </Modal.Header> 
          <Modal.Body style={{ textAlign:"left",fontSize:10}}>
          <div style={{width:"100%",textAlign:"center"}}><img style={{width:70,height:70}} src={qrlogo} alt=""/></div>
            <div style={{textAlign:"center",width:"100%",marginTop:5}}>{this.state.bodytext}</div>
{/*}          <img src={this.state.modallogo} alt="" style={{height:"25px",width:"30px", paddingRight:5}}/>*/}
          </Modal.Body>
          <Modal.Footer>

            <Button variant="secondary" onClick={this.closeModal}>
{/*}            <Button variant="secondary" onClick={this.closeModal}>*/}
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      </React.Fragment>
      )
    }
  }      